import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import classnames from 'classnames';
import moment from 'moment';

import ColorUtil from '../utils/color';
import ListPillDialog from './ListPillDialog';
import NoDeleteModal from './NoDeleteModal';


import floatingTaskActions from '../actions/floatingTaskActionCreators';
import taskActions from '../actions/taskActionCreators';
import userTaskActions from '../actions/userTaskActionCreators';

require.ensure([], () => {  
    require('./ListPill.less');
    require('./Material-Design-Iconic.less');
});

class ListPill extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            task: this.props.task,
            favorite: this.props.task.favorite,
            showInfoDialog: false
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        if (!this.state.task.projectName) {
             this.props.dispatch(floatingTaskActions.isDeletable(this.state.task.id));
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            task: nextProps.task,
            favorite: nextProps.task.favorite
        });
    }

    // EVENT HANDLERS

    handleHideTimerModal = () => {
        this.setState({
            showTimerModal: false
        });
    }

    handleHideTimesheetModal = () => {
        this.setState({
            showTimesheetModal: false
        });
    }

    handleShowTimerModal = () => {
        this.setState({
            showTimerModal: true
        });
    }

    handleShowTimesheetModal = () => {
        this.setState({
            showTimesheetModal: true
        });
    }

    // OTHER METHODS

    closeNoDeleteModal = () => {
        this.setState({
            showNoDeleteModal: false
        });
    }

    createLogEntry = () => {

        let disabled = this.props.timesheet && this.props.timesheet.status !== "ENTRY" && this.props.timesheet.status !== "FIXING";
        if (disabled)
            return;

        this.props.setFillTaskForLogEntry(this.state.task);
    }

    createTimer = () => {
        if (this.props.date.format("DD-MM-YYYY") !== moment().format("DD-MM-YYYY")) {
            this.handleShowTimerModal();
            return;
        }

        let logEntry = {
            timer: true,
            alias: this.state.task.alias,
            taskName: this.state.task.name,
            taskID: this.state.task.id,
            projectName: this.state.task.projectName,
            color: this.state.task.color,
            duration: 0,
            date: this.props.date.format("YYYY-MM-DD"),
            description: "",
            startTime: moment().format("HH:mm:ss"),
            status: "DRAFT"
        };
        
        this.props.createTimer(this.state.task, logEntry);
    }

    deleteFloatingTask = () => {
        //check if the floating task is deletable 
        if (this.props.deletableFloatingTasks[this.state.task.id]) {
           this.props.dispatch(floatingTaskActions.delete(this.state.task.id)); 
        } else {
           this.setState({
                showNoDeleteModal: true
            });
        }
    }

    toggleFavourite = () => {
        if (!this.state.task._links.setFavorite && !this.state.task._links.deleteFavorite)
            return;

        this.setState({
            favorite: !this.state.favorite
        });

        if (this.state.task._links.deleteFavorite) {
            this.state.task.favorite = false;
            this.state.task._links.setFavorite = this.state.task._links.deleteFavorite;
            this.props.dispatch(taskActions.deleteFavorite(this.state.task));
            delete this.state.task._links.deleteFavorite;
        } else if (this.state.task._links.setFavorite) {
            this.state.task.favorite = true;
            this.state.task._links.deleteFavorite = this.state.task._links.setFavorite;
            this.props.dispatch(taskActions.setFavorite(this.state.task));
            delete this.state.task._links.setFavorite;
        } else if (this.state.task._links.setFavorite && this.state.task._links.deleteFavorite) {
            throw Error("Ambiguous action: both setFavorite and deleteFavorite actions are available!");
        }
    }

    toggleInfoDialog = () => {
        this.setState({
            showInfoDialog: !this.state.showInfoDialog
        });
    }

    // RENDER METHOD

    render = () => {
        let timerModal = (
            <Modal show={true} title={<h3 style={{"textAlign" : "center"}}>Error starting timer</h3>} onRequestHide={() =>{}}>
                <div className="modal-body">
                    Timing can be done only for the current day.
                </div>
                <div className="modal-footer">
                    <Button onClick={this.handleHideTimerModal}>Close</Button>
                </div>
            </Modal>
        );

        let timesheetStatusModal = (
            <Modal show={true} title={<h3 style={{"textAlign" : "center"}}>Error creating log entry</h3>} onRequestHide={() =>{}}>
                <div className="modal-body">
                    You can not add log record if a day has been submitted, approved, or more than 30 days ago.
                </div>
                <div className="modal-footer">
                    <Button onClick={this.handleHideTimesheetModal}>Close</Button>
                </div>
            </Modal>
        );

        let dialog = (
            <ListPillDialog
                createLogEntry={this.createLogEntry}
                createTimer={this.createTimer}
                deleteFloatingTask={this.deleteFloatingTask}
                existingAliases={this.props.existingAliases}
                infoUserTask={this.props.infoUserTask}
                onRequestHide={this.toggleInfoDialog}
                pmUsers={this.props.pmUsers}
                task={this.state.task}
                timesheet={this.props.timesheet}
                />
        );

        let classNames = classnames({
            'floating': !this.props.task.projectName
        });

        let pillStyles = {};

        if (this.props.task.projectName) {
            pillStyles['borderLeft'] = "10px solid " + this.props.task.color;
        }

        let actionStyles = {};

        if (this.props.task.projectName) {
            actionStyles['backgroundColor'] = ColorUtil.RGBtoRGBA(this.props.task.color, .8);
        }

        let actions = [];

        if (this.state.task._links) {
            if (this.state.task._links.deleteFavorite)
            actions.push(<span title="Toggle favorite status" key={1} id="1" onClick={this.toggleFavourite}><i className="md-star md-2x"/></span>);
            if (this.state.task._links.setFavorite)
            actions.push(<span title="Toggle favorite status" key={1} id="1" onClick={this.toggleFavourite}><i className="md-star-outline md-2x"/></span>);
        }
        
        if (!this.state.task.projectName)
            actions.push(<span title="Delete this floating task" key={2} id="2" onClick={this.deleteFloatingTask}><i className="md-delete md-2x"/></span>);
        
        //if (this.state.task._links.createLogEntry) <- not needed
        actions.push(<span title="Create a work log for this task" key={3} id="3" onClick={this.props.timesheet && this.props.timesheet.status !== "ENTRY" && this.props.timesheet.status !== "FIXING" || moment().subtract(31, 'days').isAfter(this.props.date) ? this.handleShowTimesheetModal : this.createLogEntry}><i className="md-add md-2x"/></span>);
        
        //if (this.state.task._links.createTimer)  <- not needed
        actions.push(<span title="Start timing this task" key={4} id="4" onClick={this.props.timesheet && this.props.timesheet.status !== "ENTRY" && this.props.timesheet.status !== "FIXING" ? this.handleShowTimesheetModal : this.createTimer}><i className="md-alarm-add md-2x"/></span>);
        
        actions.push(<span title="Open task details" key={5} id="5" onClick={this.toggleInfoDialog}><i className="md-info-outline md-2x"/></span>);

        return (
            <li className={classNames} style={pillStyles}>
                { this.state.showTimerModal ? timerModal : null }
                { this.state.showTimesheetModal ? timesheetStatusModal : null }
                {
                    this.state.showInfoDialog
                    ? dialog
                    : null
                }
                {
                    this.state.showNoDeleteModal
                    ? <NoDeleteModal close={this.closeNoDeleteModal} name={this.state.task.name} />
                    : null
                }

                <div className="task">
                    <h4 style={{wordWrap : "break-word"}}>{ this.state.task.projectName ? this.state.task.projectName : "FLOATING TASK" }</h4>
                    <h5 style={{wordWrap : "break-word"}}>{ this.state.task.alias && this.state.task.alias.trim() !== '' ? this.state.task.alias : this.state.task.name }</h5>
                </div>
                <div className="task-actions" style={actionStyles}>
                    { actions }
                </div>
            </li>
        );
    }
}

ListPill.propTypes = {
    createTimer: PropTypes.func,
    createLogEntry: PropTypes.func,
    date: PropTypes.object,
    dispatch: PropTypes.func,
    existingAliases: PropTypes.array,
    id: PropTypes.string,
    infoUserTask: PropTypes.object,
    pmUsers: PropTypes.array,
    setFillTaskForLogEntry: PropTypes.func,
    task: PropTypes.object,
    timesheet: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        deletableFloatingTasks: state.floatingTasks.deletableFloatingTasks
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/ListPill.js
 **/